import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Enlightenment_&_Revolutions_-_French_Revolution.png';

function HistoryPageFrenchRevolutionGo() {
  return (
    <QuizPage
      title="History: French Revolution"
      subTopic="French Revolution"
      backgroundImage={historyImage}
      returnPath="/History-French-Revolution"
    />
  );
}

export default HistoryPageFrenchRevolutionGo;
